/* eslint-disable @next/next/no-img-element */
import styles from "./GuideData.module.scss";
import format from "date-fns/format";
import { formatLocationString } from "../utils/format";
import { insertTagsInCloudinaryUrl } from "utils/image";

export default function GuideData({
  preferences,
  trip_data,
  image,
  location,
  itineraryLength,
}) {
  if (!preferences || !trip_data || !location) {
    return null;
  }

  const { accommodation, activities, travel_style, budget } = preferences;
  const { duration_days } = trip_data;

  const locationString = formatLocationString({
    location: {
      city: location?.city,
      region: location?.region,
      country: location?.country,
    },
  });

  const budgetOptions = {
    low_budget: "$",
    average_budget: "$$",
    high_budget: "$$$",
    luxury_budget: "$$$$",
  };

  return (
    <section
      className={`${styles.container} ${!image ? styles.noImage : ""} variable-container`}
      id="inputs"
    >
      <div className={`${styles.data}`}>
        <div className={`${styles.content}`}>
          <p className={`${styles.title}`}>Personalized for these inputs:</p>
          <ul className={`${styles.list}`}>
            <DataListItem dataKey="Destination" value={locationString} />
            <DataListItem
              dataKey="Trip length"
              value={
                duration_days
                  ? `${duration_days} ${duration_days !== 1 ? "days" : "day"}`
                  : `${itineraryLength} days`
              }
            />
            <DataListItem
              dataKey="Trip dates"
              value={
                trip_data?.from
                  ? `${format(new Date(trip_data?.from), "MMMM dd")} - ${format(
                      new Date(trip_data?.to),
                      "MMMM dd"
                    )}`
                  : null
              }
            />
            <DataListItem
              dataKey="Travel style"
              value={travel_style?.replaceAll("-", " ")}
            />
            <DataListItem dataKey="Budget" value={budgetOptions[budget]} />
            <DataListItem
              dataKey="Accommodation"
              value={accommodation?.replaceAll("-", " ")}
            />
            <DataListItem
              dataKey="Activities"
              value={activities?.replaceAll("-", " ")}
            />
          </ul>
        </div>
      </div>
      {!!image && (
        <div className={`${styles.imageWrapper}`}>
          <picture>
            <source
              srcSet={insertTagsInCloudinaryUrl(
                image?.url,
                `c_auto,ar_1.0,g_auto,w_720,q_auto,f_auto`
              )}
              media="(max-width: 768px)"
            />
            <source
              srcSet={insertTagsInCloudinaryUrl(
                image?.url,
                `c_auto,ar_1.0,g_auto,w_480,q_auto,f_auto`
              )}
              media="(max-width: 992px)"
            />
            <img
              src={insertTagsInCloudinaryUrl(
                image?.url,
                `c_auto,ar_1.0,g_auto,w_720,q_auto,f_auto`
              )}
              alt={image?.alternativeText}
              // fill={true}
              loading="lazy"
              className={`${styles.image}`}
              sizes="(max-width: 640px) 640px"
            />
          </picture>
        </div>
      )}
    </section>
  );
}

function DataListItem({ dataKey, value = "None" }) {
  return (
    <li className={`${styles.listItem}`}>
      <span className={`${styles.key}`}>{dataKey}: </span>
      <span>{value ?? "None"}</span>
    </li>
  );
}
